module.exports = __webpack_public_path__ + "static/media/icon-twitter.6eef62ff.svg";